import { IFeedbackResponseData } from '../../../pages/FeedbackResponse/FeedbackResponseConstants';
import { IUserResponse } from '../../models/UserModels';
import { API_ROUTE } from '../ApiRoute';
import ApiService from '../ApiService';
import ApiServiceBase from '../ApiServiceBase';
import { ServerType, ServiceType } from '../ServiceType.data';

const serviceType = ServiceType.None;

export class FeedbackService {
  private readonly service: ApiServiceBase = new ApiService(serviceType, ServerType.tangra);

  private readonly dcaBackendService: ApiServiceBase = new ApiService(
    ServiceType.None,
    ServerType.dcaBackend,
  );

  public getFeedback(): Promise<IFeedbackResponseData[]> | IFeedbackResponseData[] {
    return this.dcaBackendService.get({ route: [API_ROUTE.FEEDBACK] });
  }
  public postFeedback(body: any): Promise<string> | string {
    return this.dcaBackendService.post({ route: [API_ROUTE.FEEDBACK] }, body);
  }
}

const feedbackService = new FeedbackService();
export default feedbackService;
